import { Form } from 'dashboard-js/forms/Form'

window.SparkForm = Form
